import { paths } from "_core/types";

const sleep = (m: number) => new Promise((r) => setTimeout(r, m));

interface ReqConf {
  base: string;
  path: keyof paths;
  options?: RequestInit;
  timesToTry?: number;
  retryTimeout?: number;
  noRetryStatuses?: Array<number>;
}

export const fetchClient = async <T>({
  base,
  path,
  options = {},
  timesToTry = 3,
  retryTimeout = 3000,
  noRetryStatuses = [400, 401, 404],
}: ReqConf): Promise<T> => {
  try {
    const res = await fetch(`${base}${path}`, options);
    if (res?.ok) {
      return res.json();
    }
    throw res;
  } catch (err) {
    if (
      timesToTry <= 1 ||
      noRetryStatuses.includes((err as Response).status) ||
      process.env.BUILD_ENV !== "prod"
    ) {
      throw err;
    }
    await sleep(retryTimeout);
    return fetchClient({
      base,
      path,
      options,
      timesToTry: timesToTry - 1,
      retryTimeout,
    });
  }
};
